import { keyframes } from '@emotion/react';

export const slideDown = (height: string) =>
  keyframes({
    from: { height: 0 },
    to: { height },
  });

export const slideUp = (height: string) =>
  keyframes({
    from: { height },
    to: { height: 0 },
  });
